




























































import SelectYearMounth from "@/shared/components/select-year-mounth.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import dayjs from "dayjs";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import Aquisicao from "./Aquisicao.vue";
import Financeiro from "./Financeiro.vue";
import FinanceiroDiario from "./FinanceiroDiario.vue";

@Component({
  components: {
    Aquisicao,
    Financeiro,
    SelectYearMounth,
    FinanceiroDiario,
  },
  filters: {},
})
export default class Dashboard extends mixins(GlobalMixin) {
  tab = "aquisicao";
  data: string | null = dayjs().format("YYYY-MM");
}
